import React from "react";
import {Page, Text, View, Document, StyleSheet, Font} from "@react-pdf/renderer";
import OpenSansRegular from "../../../../../statics/typos/openSansRegular.ttf";
import OpenSansSemiBold from "../../../../../statics/typos/openSansSemiBold.ttf";
import OpenSansBold from "../../../../../statics/typos/openSansBold.ttf";
import {OrderCargoFileModel} from "../../../../models/order";
import {OrderFilesUtils} from "../../../../../helpers/orderFilesUtils";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSansRegular
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold
});

const styles = StyleSheet.create(OrderFilesUtils.styles);

interface ExportOrderCargoFileProps {
    order: OrderCargoFileModel | null | undefined,
    username: string
}

export default function ExportOrderCargoFile(props: ExportOrderCargoFileProps): React.ReactElement {
    if (!props.order) {
        return <Document><Page/></Document>;
    }

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    {OrderFilesUtils.renderHeader("ZLECENIE ZŁOŻENIA ŁADUNKU CARGO W EKSPORCIE \n " +
                        "EXPORT ORDER CARGO")}
                    {renderTable()}
                </View>
            </Page>
        </Document>
    );

    function renderTable() {
        return (
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderOrderType(props.order!.relationType)}
                    {OrderFilesUtils.renderOrderNo(props.order!.orderId)}
                    {OrderFilesUtils.renderBookingNo(props.order!.bookingNo)}
                    {OrderFilesUtils.renderVoyageNo(props.order!.voyageNo)}
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Rodzaj środka transportu /{"\n"}
                            Type of means of transport
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderTransportType(props.order!.relationType)}
                        </Text>
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Nr środka transportu /{"\n"}
                            Means of transport no
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderMeansOfTransportNo({
                                trailerRegNo: props.order!.trailerRegNo,
                                lorryRegNo: props.order!.lorryRegNo
                            })}
                        </Text>
                    </View>
                    {OrderFilesUtils.renderCargoType(props.order!.cargoType)}
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Nr identyfikacyjny /{"\n"}
                            Identification no
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderMeansOfTransportNo({
                                wagonRegNo: props.order!.wagonRegNo,
                                containerNo: props.order!.containerNo
                            })}
                        </Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableMediumCol}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, {
                                width: "33.4%",
                                height: "100%",
                                borderRightWidth: 1,
                                borderBottom: 0
                            }]}>
                                {OrderFilesUtils.renderFerry(props.order!.ferryName)}
                            </View>
                            <View style={[styles.tableCol, {
                                width: "33.4%",
                                height: "100%",
                                borderRightWidth: 1,
                                borderLeftWidth: 0,
                                borderBottom: 0
                            }]}>
                                {OrderFilesUtils.renderArrivalDepartureTime(props.order!.arrivalDepartureTime)}
                            </View>
                            <View style={[styles.tableCol, {
                                width: "33.3%", height: "100%", borderWidth: 0
                            }]}>
                                {OrderFilesUtils.renderCargoWeight(props.order!.weight)}
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, {
                                width: "33.4%",
                                height: "100%",
                                borderTopWidth: 1,
                                borderRightWidth: 1,
                                borderBottom: 0
                            }]}>
                                {OrderFilesUtils.renderDangerousGoods(props.order!.isDangerousGoods)}
                            </View>
                            <View style={[styles.tableCol, {
                                width: "33.4%",
                                height: "100%",
                                borderTopWidth: 1,
                                borderRightWidth: 1,
                                borderLeftWidth: 0,
                                borderBottom: 0
                            }]}>
                                {OrderFilesUtils.requestedTemp(props.order!.requestedTemp1, 1)}
                            </View>
                            <View style={[styles.tableCol, {
                                width: "33.3%",
                                height: "100%",
                                borderTopWidth: 1,
                                borderWidth: 0
                            }]}>
                                {OrderFilesUtils.requestedTemp(props.order!.requestedTemp2, 2)}
                            </View>
                        </View>
                    </View>
                    {OrderFilesUtils.renderCbm(props.order!.cbm)}
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableBigCol}>
                        {OrderFilesUtils.renderTransportCompany(props.order!.transportCompany)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderTimeOfDepositingLoad(props.order!.timeOfDepositingLoad)}
                    <View style={styles.tableCol}>
                        {OrderFilesUtils.renderStorageTime(props.order!.storageTime)}
                    </View>
                    {OrderFilesUtils.renderPaymentWaiver(props.order!.parkingCost)}
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderPaymentMethod(props.order!.paymentMethod)}
                    {OrderFilesUtils.renderPaymentDocumentNumber(props.order!.paymentDocumentNumber)}
                </View>
                {OrderFilesUtils.renderRemarks(props.order!.remarks)}
                {OrderFilesUtils.requestedSignatures(false, props.username)}
            </View>
        );
    }
}

